import { useAuthQuery } from 'hooks';
import { DocumentType } from 'types';

export const useMemberDocuments = (memberId: number | undefined) => {
  return useAuthQuery<DocumentType[]>(['members', memberId, 'documents'], {
    enabled: !!memberId,
  });
};
